import React, { Fragment, useState, useEffect } from 'react';
import axios from "axios";
import styles from "./TeacherModal.module.sass";
import ModalContent from './ModalContent';
import Spinner from "../../Spinner";
import { summarizeTeacherWarnings, summaryDetail } from '../../../utils/teacherWarnings';

const TeacherList = ({ schoolId }) => {
  const [data, setData] = useState();
  // The rows as they stand after edits (ModalContent owns them), so the
  // summary follows a fix instead of showing the page as it loaded.
  const [current, setCurrent] = useState();

  const getTeachers = () => {
    axios
      .get(`/api/v1/students/students_per_teacher?school_id=${schoolId}`)
      .then((data) => {
        setData(data.data.data)
      })
  }

  useEffect(() => {
    getTeachers();
  }, [schoolId])

  return (
    <Fragment>
      {!data && <Spinner color="blue" />}
      {data && (
        <>
          {data.some((teacher) => teacher.needs_review) && (
            <p>
              Highlighted teachers need review — no staff record could be confidently
              matched, so their display name must be entered or linked by hand.
            </p>
          )}
          <hr />
          {(() => {
            const rows = current || data;
            const { flagged, names } = summarizeTeacherWarnings(rows);
            const detail = summaryDetail(names);
            return flagged === 0 ? (
              <div className={styles.summaryOk}>
                <strong>Check Teachers:</strong>
                {` nothing flagged for ${rows.length} teachers.`}
              </div>
            ) : (
              <div className={styles.summary}>
                <strong>Check Teachers:</strong>
                {` ${flagged} of ${rows.length} teachers need a look (yellow rows): ${detail}.`}
              </div>
            );
          })()}
          <ModalContent data={data} schoolId={schoolId} onChange={setCurrent} />
        </>
      )}
    </Fragment>
  )
}

export default TeacherList;
